export default () => ({
  user: null,
  token: null,
  verify: null,
  error: '',
  info: '',
});
